import { useState, useEffect } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const stripeService = {
  _url: process.env.REACT_APP_MAIN_URL,
  _stripe: `${process.env.REACT_APP_USER_API_URL}/stripe`,

  GetInvoices(searchQuery, fetch) {
    const [invoices, setInvoices] = useState({
      invoices: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getInvoices(searchQuery))
        .then(res => {
          setInvoices(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);
    return {
      invoices_loading: status === STATUS.LOADING,
      invoices_error: status === STATUS.ERROR,
      invoices_data: invoices?.data,
      invoices_pagination: invoices?.pagination,
    };
  },

  async getAllPlans() {
    let res = await Fetch.get(`${this._url}/plans`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getStripePlans() {
    let res = await Fetch.get(`${this._stripe}/plans`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async updateSubscription(payload) {
    let res = await Fetch.post(`${this._stripe}/update-subscription-checkout`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async createCheckoutSession(payload) {
    let res = await Fetch.post(`${this._stripe}/create-checkout-session`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async createSetupIntent() {
    let res = await Fetch.post(`${this._stripe}/workspace-admin/setup-intent`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async confirmWorkspaceAdminPayment(payload) {
    let res = await Fetch.post(`${this._stripe}/workspace-admin/confirm-payment`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async startSubscription(payload) {
    let res = await Fetch.post(`${this._stripe}/workspace-admin/start-subscription`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async activatePackage() {
    let res = await Fetch.post(`${this._stripe}/end-trial-now`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async cancelSubscription() {
    let res = await Fetch.post(`${this._stripe}/cancel-subscription`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async cancelMemberSubscription(userId) {
    let res = await Fetch.post(`${this._stripe}/member/cancel-subscription/${userId}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getInvoices({ itemsPerPage = 10, cursor = '' }) {
    let res = await Fetch.get(`${this._stripe}/invoices?itemsPerPage=${itemsPerPage}&cursor=${cursor}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Failed to fetch invoices');
  },
  async updateMemberSubscription(payload) {
    let res = await Fetch.post(`${this._stripe}/member/change-plan`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async saveCardDetails(payload) {
    let res = await Fetch.post(`${this._stripe}/save-card`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};
export default stripeService;
